import {
  PRODUCT_LINE_GOALS_PERSIST,
  PRODUCT_LINE_GOALS_PERSIST_SUCCESS,
  PRODUCT_LINE_GOALS_PERSIST_FAILURE
} from 'Goals/constants/ProductLines'

export const productLineGoalsPersist = payload => ({ payload, type: PRODUCT_LINE_GOALS_PERSIST })
export const productLineGoalsPersistSuccess = payload => ({ payload, type: PRODUCT_LINE_GOALS_PERSIST_SUCCESS })
export const productLineGoalsPersistFailure = payload => ({ payload, type: PRODUCT_LINE_GOALS_PERSIST_FAILURE })
